// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"177":"534819fb","328":"284b05c0","365":"064f6f99","571":"90b888c1","821":"adf13aac"}[chunkId] + ".css";
};